import {createStore} from 'vuex'
import manba from 'manba'
import Common from './api/common'
import {generateUserMenu} from './router';
import setting from "@/api/setting";
import {ArrToObj} from "@/js/common/utils";

const SubjectType = {
  ASSET: "资产",
  LIABILITY: "负债",
  RIGHTS: "权益",
  COST: "成本",
  INCOME: "损益",
  COMMON: "共同",
  NET_ASSETS: "净资产",
  REVENUE: "收入",
  EXPENSES: "费用"
};

export default createStore({
  state: {
    User: {
      name: '',
      desc: '执着于理想，纯粹于当下',
      email: '',
      org: '',
      dept: '研发部',
      title: '高级软件工程师',
      location: '',
      avatar: '/images/avatar.png',
      roleInfo: {},
      checkoutList: [],
      modules: []
    },
    webConfig: {
      "name": "",
      "company": "",
      "loginLogo": "",
      "loginSlogan": "",
      "loginSubSlogan": "",
      "loginLeftBg": "",
      "loginLeftCh": "",
      "copyright": "",
      "icp": "",
      "homeLogo": "",
      "qrCode": "",
      "register": true,
      "experienceDays": 30,
      "notice": "",
      "about": ""
    },
    prod: false,
    currentAccountSets: {},
    myAccountSets: [],
    tabs: [{
      key: "Home",
      title: "首页"
    }],
    reportList: [],
    subjectType: [],
    menus: [],
    currentTab: 'Home',
    currencyMap: {},
    voucherWords: [],
    lastDate:null,
    selectOrigin:null,
    sliderCollapsed: false,
    tabParams:null,
    formDate:null,
    workbenchPage: null,   // 工作台模式(isManage==1)下的页面切换
  },
  mutations: {
    updateTabs(state, payload) {
      state.tabs = payload;
    },
    newTab(state, tab) {
      let find = state.tabs.find(val => val.key === tab.key);
      if (!find) {
        state.tabs.push(tab);
      }
      state.tabParams = tab.tabParams;
      state.currentTab = tab.key;
      if(tab.selectOrigin){
        state.selectOrigin = tab.selectOrigin;
      }else{
        state.selectOrigin = null;
      }
      localStorage.setItem(this.getters.currentTabAllKey, JSON.stringify(state.tabs));
    },
    changeTab(state, tabKey) {
      state.currentTab = tabKey;
      // 更新当前tab的tabParams
      const currentTab = state.tabs.find(tab => tab.key === tabKey);
      if (currentTab) {
        state.tabParams = currentTab.tabParams || {};
      } else {
        state.tabParams = {};
      }
    },
    updateCurrency(state, currencyMap) {
      state.currencyMap = currencyMap;
    },
    updateVoucherWords(state, voucherWords) {
      state.voucherWords = voucherWords;
    },
    updateWebConfig(state, webConfig) {
      state.webConfig = webConfig;
    },
    updateReportList(state, reportList) {
      state.reportList = reportList;
    },
    refreshTab(state, tab) {
      // console.log('tab==',tab);
      let find = state.tabs.findIndex(val => val.key === tab.key);
      if (find !== -1) {
        state.tabs.splice(find, 1);
      }
      setTimeout(() => {
        state.tabs.push(tab);
      })
      state.tabParams = tab.tabParams;
      state.currentTab = tab.key;
      if(tab.lastDate){
        state.lastDate = tab.lastDate;
      }else{
        state.lastDate = null;
      }
      if(tab.selectOrigin){
        state.selectOrigin = tab.selectOrigin;
      }else{
        state.selectOrigin = null;
      }
      localStorage.setItem(this.getters.currentTabAllKey, JSON.stringify(state.tabs));
    },
    closeTab(state, tabKey) {
      let find = state.tabs.findIndex(val => val.key === tabKey);
      if (find !== -1) {
        let next = Math.max(0, find - 1);
        state.currentTab = state.tabs[next].key;
        state.tabs.splice(find, 1);
      }
      localStorage.setItem(this.getters.currentTabAllKey, JSON.stringify(state.tabs));
    },
    updateAccount(state, user) {
      state.User = user;
      state.currentAccountSets = user.accountSets;
      if (user.accountSets) {
        state.subjectType = user.accountSets.subjectCategory.map(val => SubjectType[val]);
      }
      state.myAccountSets = user.accountSetsList;
      state.menus = generateUserMenu(user.roleInfo?.astAdmin, user.roleInfo?.authorities, user.modules?.reduce((map, item) => {
        map[item.moduleKey] = item;
        return map;
      }, {}));
    },
    updateSliderCollapse(state, isShow) {
      setTimeout(() => {
        G.trigger('page_resize');
      }, 600);
      state.sliderCollapsed = isShow;
    },
    updateProd(state, isProd = false) {
      state.prod = isProd;
    },
    updateCurrentAccountDate(state, date) {
      state.currentAccountSets.currentAccountDate = date;
    },
    updateCurrentAccountDateStatus(state, status) {
      state.currentAccountSets.currentAccountDateStatus = status;
    },
    updateFormDate(state, date) {
      state.formDate = date;
    },
    // 工作台模式(isManage==1)切换页面
    switchWorkbenchPage(state, payload) {
      // payload: { key: 'CheckAccountReport', params: { ... } }
      state.workbenchPage = payload;
    },
    updateTabParams(state, { key, tabParams }) {
      const tab = state.tabs.find(tab => tab.key === key);
      if (tab) {
        tab.tabParams = { ...tab.tabParams, ...tabParams };
      }
      state.tabParams = { ...state.tabParams, ...tabParams };
    },
  },
  actions: {
    init(context) {
      return new Promise((resolve, reject) => {
        Common.init().then(({data}) => {
          context.commit('updateAccount', data.user);
          context.commit('updateCurrency', data.currency);
          context.commit('updateProd', data.prod);
          context.commit('updateReportList', data.reportList);
          context.commit('updateWebConfig', data.webConfig);

          data?.user?.accountSets && context.dispatch('voucherWords');

          resolve(data)
        }).catch(({data, message}) => {
          data && context.commit('updateWebConfig', data.webConfig);
          reject();
        })
      });
    },
    updateCurrency(context) {
      setting.currency.list().then(({data}) => {
        context.commit('updateCurrency', ArrToObj(data, val => val.id));
      })
    },
    voucherWords(context) {
      setting.voucherWord.list().then(({data}) => {
        context.commit('updateVoucherWords', data);
      })
    }
  },
  getters: {
    currentTabKey: state => "currentTab:" + (state.currentAccountSets?.id || ''),
    currentTabAllKey: state => "currentTabAll:" + (state.currentAccountSets?.id || ''),
    /**
     * 本位币
     * @param state
     * @returns {unknown}
     */
    localCurrency: state => {
      return Object.values(state.currencyMap).find(val => val.localCurrency)
    },
    currencySelectData: state => {
      // {id: 1,name: "综合本币",localCurrency:false}
      let cData = [{id: 0,name: "综合本位币",localCurrency:false},...Object.values(state.currencyMap)];
      let a = [];
      for(let obj of cData){
        if(obj.localCurrency){
          continue;
        }
        a.push(obj);
      }
      return a;
    },
    simplyCurrencySelectData: state => {
      return Object.values(state.currencyMap)
    },
    encodingLvs: state => {
      return (state.currentAccountSets?.encoding || []).map((item, index) => index + 1);
    },
    tabMap: state => {
      const map = {};
      state.tabs.forEach(item => {
        map[item.key] = item;
      })
      return map;
    },
    modulesMap: state => {
      return state.User.modules?.reduce((map, item) => {
        map[item.moduleKey] = item;
        return map;
      }, {})
    },
    account: state => {
      return state.User;
    },
    checkoutList: state => {
      return state.User.checkoutList;
    },
    lastCheckoutDate: state => {
      return state.User.checkoutList?.filter(it => it.status !== 2).pop()?.checkDate || state.currentAccountSets.enableDate;
    },
    firstCheckoutDate: state => {
      let reverse = state.User.checkoutList.filter(val => val.status !== 2).reverse();
      if (reverse.length) {
        return reverse[0].checkDate;
      }
      return manba().startOf(manba.MONTH).format();
    },
    checkoutSelect: state => {
      return state.User.checkoutList.map(row => {
        const m = row.checkMonth < 10 ? '0' + row.checkMonth : row.checkMonth;
        return {
          key: row.checkYear + '年' + m + "期",
          title: row.checkYear + '年' + m + "期",
        }
      });
    },
    sliderCollapsed: state => {
      return state.sliderCollapsed;
    },
    roleInfo: state => {
      return state.User.roleInfo;
    },
    authorities: state => {
      return state.User.roleInfo?.authorities || [];
    }
  }
})
